import { status } from 'skin/event/status';
import ctg from './category'
import prd from './product'

const add = (obj, form, story, data, d, action) => {
	switch (obj.table) {
		case 'goodsCategory':
			return ctg(obj, form, story, data, d, action);
		case 'goodsProduct':
			return prd(obj, form, story, data, d, action);
		default:
			return status.action;
	}
};

export default add;
